import { DocumentNode } from 'graphql';
import { MutationHookOptions } from '@apollo/react-hooks';
import { gql, MutationUpdaterFn, ApolloError } from 'apollo-boost';

interface IMutationObject {
	mutation: DocumentNode;
	options: MutationHookOptions;
}
const mutation = gql`
	mutation createDeliveryNumber($input: CreateDeliveryNumberInput!) {
		createDeliveryNumber(input: $input) {
			deliveryNumber {
				id
				deliveryNumber
				palletListId
			}
		}
	}
`;

const GET_PALLET_LIST = gql`
	query palletList($id: String!) {
		palletList(id: $id) {
			id
			createdAt
			itemCount
			shipmentCount
			shipmentCount
			lastUpdatedAt
			emailDeliveryCount
			createdBy {
				name
				id
			}
			deliveryNumbers {
				id
				deliveryNumber
			}
			items {
				id
				createdAt
				poNumber
				product {
					id
					description
					eanCode
				}
			}
		}
	}
`;

function getUpdateFunction(palletListId: string): MutationUpdaterFn {
	const updater: MutationUpdaterFn<any> = (
		cache,
		{
			data: {
				createDeliveryNumber: { deliveryNumber },
			},
		}
	) => {
		const { palletList }: any = cache.readQuery({ query: GET_PALLET_LIST, variables: { id: palletListId } });
		palletList.deliveryNumbers = [...palletList.deliveryNumbers].concat([deliveryNumber]);
		cache.writeQuery({
			query: GET_PALLET_LIST,
			data: {
				palletList: {
					...palletList,
				},
			},
		});
	};

	return updater;
}

function getMutation(variables: { palletListId: string }, onCompleted?: (data: any) => void, onError?: (error: ApolloError) => void) {
	const mutationObject: IMutationObject = {
		mutation,
		options: {
			update: getUpdateFunction(variables.palletListId),
			onCompleted,
			onError,
		},
	};
	return mutationObject;
}

export default getMutation;
